module.exports = __webpack_public_path__ + "img/full3-min.6d12aa87.png";